import { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { Draft, produce } from 'immer';

function migrateComponentInstanceDraft(draftComponentInstance: Draft<ComponentInstance>) {
  // Delete legacy properties that should no longer be there in any component instance
  delete draftComponentInstance.css;
  delete draftComponentInstance.composite_instance_changed;
  delete draftComponentInstance.editable_by_user;
  delete draftComponentInstance.created_by;
  delete draftComponentInstance.description_name;
  delete draftComponentInstance.description_version;
  delete draftComponentInstance.args_definition;
  delete draftComponentInstance.events;
  delete draftComponentInstance.css_classes;
  delete draftComponentInstance.style_classes;
  delete draftComponentInstance.intro;
  delete draftComponentInstance.info;
  delete draftComponentInstance.layout_args;
  // Recursively migrate all the child components
  draftComponentInstance.children.forEach(migrateComponentInstanceDraft);
}

const migrateComponentInstance = produce<ComponentInstance>((draftComponentInstance) => {
  migrateComponentInstanceDraft(draftComponentInstance);
});

export default migrateComponentInstance;
